(() => {
  if (customElements.get("p-card-swiper")) return;
  
  class PCardSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.boundResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.sectionElement = this.closest("section");
      this.swiperElement = this.querySelector(".p-card-swiper__swiper");
      this.paginationEl = this.querySelector(".p-card-swiper__pagination");
      this.mobileBreakpoint = parseInt(this.dataset.mobileBreakpoint || "767", 10);
      this.enableLoop = this.dataset.loop === "true";
      this.enableAutoplay = this.dataset.autoplay === "true";
      this.autoplayDelay = parseInt(this.dataset.autoplayDelay || "3500", 10);
      this.spaceBetween = this.resolveCardGap();
      this.slidesPerView = this.resolveSlidesPerView();

      this.waitForSwiper(() => {
        this.handleResize();
        window.addEventListener("resize", this.boundResize);
      });
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.boundResize);
      this.destroySwiper();
    }

    waitForSwiper(callback, retry = 0) {
      if (typeof window.Swiper === "function") {
        callback();
        return;
      }
      if (retry > 20) return;
      setTimeout(() => this.waitForSwiper(callback, retry + 1), 120);
    }

    shouldUseSwiper() {
      return window.innerWidth > this.mobileBreakpoint;
    }

    resolveCardGap() {
      const gapRaw = this.sectionElement
        ? window.getComputedStyle(this.sectionElement).getPropertyValue("--card-gap")
        : "";
      const gap = parseFloat(gapRaw);
      return Number.isFinite(gap) ? gap : 20;
    }

    resolveSlidesPerView() {
      const mode = this.dataset.slidesPerViewMode || "fixed";
      if (mode === "auto") return "auto";

      const value = parseFloat(this.dataset.slidesPerView || "1.75");
      return Number.isFinite(value) ? value : 1.75;
    }

    handleResize() {
      if (!this.swiperElement) return;

      if (this.shouldUseSwiper()) {
        this.spaceBetween = this.resolveCardGap();
        this.slidesPerView = this.resolveSlidesPerView();
        this.initSwiper();
        if (this.swiperInstance) {
          this.swiperInstance.params.spaceBetween = this.spaceBetween;
          this.swiperInstance.params.slidesPerView = this.slidesPerView;
          this.swiperInstance.update();
        }
        return;
      }

      this.destroySwiper();
    }

    initSwiper() {
      if (this.swiperInstance || typeof window.Swiper !== "function") return;

      const swiperOptions = {
        slidesPerView: this.slidesPerView,
        spaceBetween: this.spaceBetween,
        watchOverflow: true,
        speed: 600,
        loop: this.enableLoop,
        pagination: {
          el: this.paginationEl,
          clickable: true
        }
      };

      if (this.enableAutoplay) {
        swiperOptions.autoplay = {
          delay: this.autoplayDelay,
          disableOnInteraction: false
        };
      }

      this.swiperInstance = new window.Swiper(this.swiperElement, swiperOptions);
    }

    destroySwiper() {
      if (!this.swiperInstance) return;
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  customElements.define("p-card-swiper", PCardSwiper);
})();
